import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import React from 'react'
import DropMeLoc from "./DropMeLoc"; 
import GLOBALS from "../../utils/Globals";
import Footer from "../Footer/Footer";

function ImportLoc() {
  
  return (
    <>
      <br></br>
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="sm:flex sm:items-center">
          <div className="sm:flex-auto">
            <h1 className="text-xl font-semibold text-gray-900">
              Import Multiple GLN Data Files and Combine Them
            </h1>
            <p className="mt-2 text-sm text-gray-700">
              To import GLN data, drag and drop multiple files
            </p>

            <br></br>
            <DropMeLoc />
          </div>
        </div>
      </div>
      <br></br>
      <Footer />
    </>
  );
}

export default ImportLoc